import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/octicons/octicons/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Caption, Do, Dont } from '@primer/gatsby-theme-doctocat';
import { Grid, Flex, Box } from '@primer/components';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DoDontContainer = makeShortcode("DoDontContainer");
const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Use octicons to symbolize metaphors and actions common to GitHub. When using octicons keep the following principles in mind:`}</p>
    <ol>
      <li parentName="ol">{`Octicons are used to `}<em parentName="li">{`emphasize`}</em>{` meaning, not as a replacement`}</li>
      <li parentName="ol">{`Adding an octicon should be intentional`}</li>
      <li parentName="ol">{`Not everything needs an icon: consider a text label before adding an icon`}</li>
      <li parentName="ol">{`Keep octicons at their aspect ratio`}</li>
    </ol>
    <h2>{`Color`}</h2>
    <p>{`For most components, icon color has been set using our functional color variables. `}</p>
    <img width="960" alt="Components with octicons already embedded have their color styles preset. This is an example of a flash alert where the alert icon and close icon are preset to a dark yellow." src="https://user-images.githubusercontent.com/10384315/103851338-69f8e800-505e-11eb-9bed-4a3a7c5b94d3.png" />
    <p>{`Some use cases allow for icons to be paired with a specific color based on the intended function. Use the table below as a reference.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Example`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Color variable`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Usage`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path fillRule="evenodd" d="M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM0 8a8 8 0 1116 0A8 8 0 010 8zm6.5-.25A.75.75 0 017.25 7h1a.75.75 0 01.75.75v2.75h.25a.75.75 0 010 1.5h-2a.75.75 0 010-1.5h.25v-2h-.25a.75.75 0 01-.75-.75zM8 6a1 1 0 100-2 1 1 0 000 2z" fill="#0366D6"></path></svg></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`icon-info`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Used to indicate important information`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path fillRule="evenodd" d="M13.78 4.22a.75.75 0 010 1.06l-7.25 7.25a.75.75 0 01-1.06 0L2.22 9.28a.75.75 0 011.06-1.06L6 10.94l6.72-6.72a.75.75 0 011.06 0z" fill="#22863A"></path></svg></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`icon-success`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Used to indicate a successful, passing, or positive result`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path fillRule="evenodd" d="M3.72 3.72a.75.75 0 011.06 0L8 6.94l3.22-3.22a.75.75 0 111.06 1.06L9.06 8l3.22 3.22a.75.75 0 11-1.06 1.06L8 9.06l-3.22 3.22a.75.75 0 01-1.06-1.06L6.94 8 3.72 4.78a.75.75 0 010-1.06z" fill="#D73A49"></path></svg></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`icon-danger`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Used to indicate an error, danger, or negative result`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path fillRule="evenodd" d="M8.22 1.754a.25.25 0 00-.44 0L1.698 13.132a.25.25 0 00.22.368h12.164a.25.25 0 00.22-.368L8.22 1.754zm-1.763-.707c.659-1.234 2.427-1.234 3.086 0l6.082 11.378A1.75 1.75 0 0114.082 15H1.918a1.75 1.75 0 01-1.543-2.575L6.457 1.047zM9 11a1 1 0 11-2 0 1 1 0 012 0zm-.25-5.25a.75.75 0 00-1.5 0v2.5a.75.75 0 001.5 0v-2.5z" fill="#B08800"></path></svg></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`icon-warning`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Used to indicate warning`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Sizing`}</h2>
    <p>{`Octicons are primarily available in two sizes: 16px and 24px. They should only be used at their dedicated sizes to maintain consistency in stroke width and legibility.`}</p>
    <p>{`A limited set of 12px icons are available for specific usage within condensed UI and are listed below.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Icon`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Usage`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/138614527-c7d8aedb-e608-4768-9443-687fc1d5ed23.png",
              "alt": "12px alert fill icon"
            }}></img></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://primer.style/octicons/alert-fill-12"
            }}><inlineCode parentName="a">{`alert-fill`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`For cautionary messaging or to inform the user that an action requires attention`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/138614538-b4f5c1d0-6705-4a08-bc8c-2ce553acb4d6.png",
              "alt": "12px check circle icon"
            }}></img></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://primer.style/octicons/check-circle-fill-12"
            }}><inlineCode parentName="a">{`check-circle-fill`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`For positive messaging to inform the user that an action is successful, complete, or that they may continue through a workflow`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/138614561-7ddc158b-932c-4f2f-854e-abba316676d9.png",
              "alt": "12px no entry icon"
            }}></img></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://primer.style/octicons/no-entry-fill-12"
            }}><inlineCode parentName="a">{`no-entry-fill`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Indicate an ending or that the user is blocked and cannot continue`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/138614582-72db2bad-ca03-4741-aaf9-c30095a831e7.png",
              "alt": "12px x circle icon"
            }}></img></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><a parentName="td" {...{
              "href": "https://primer.style/octicons/x-circle-fill-12"
            }}><inlineCode parentName="a">{`x-circle-fill`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`For negative messaging to inform the user that an error has occurred as a result of an action or an action is unavailable`}</td>
        </tr>
      </tbody>
    </table>
    <Dont mdxType="Dont">
      <img width="960" alt="Scaling the 16px icon larger causes the stroke to become too thick. Scaling the 24px icon smaller causes the stroke to become too thin." src="https://user-images.githubusercontent.com/10384315/103834253-c1d02880-5037-11eb-8106-db3acd64cfc3.png" />
      <Caption mdxType="Caption">Scaling icons from their original size is not permitted.</Caption>
    </Dont>
    <h2>{`Special icons`}</h2>
    <p>{`Certain octicons are intended for a specific use case. Refer to the table below for icons with specific guidelines.`}</p>
    <h3>{`Git specific`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Icon`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Metaphor`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Usage`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path fillRule="evenodd" d="M10.5 7.75a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm1.43.75a4.002 4.002 0 01-7.86 0H.75a.75.75 0 110-1.5h3.32a4.001 4.001 0 017.86 0h3.32a.75.75 0 110 1.5h-3.32z"></path></svg></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><strong parentName="td">{`Commits`}</strong></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`The `}<inlineCode parentName="td">{`commit`}</inlineCode>{` icon is represented as a circle on a line. This symbolizes a point (the circle) along the version history timeline when changes were made. Use this icon in views to represent individual or groups of commits, including the timeline and the `}<strong parentName="td">{`Commits`}</strong>{` tab in pull requests`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path d="M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"></path><path fillRule="evenodd" d="M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z"></path></svg>{` `}<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path d="M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z"></path><path fillRule="evenodd" d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"></path></svg>{` `}<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path d="M5.029 2.217a6.5 6.5 0 019.437 5.11.75.75 0 101.492-.154 8 8 0 00-14.315-4.03L.427 1.927A.25.25 0 000 2.104V5.75A.25.25 0 00.25 6h3.646a.25.25 0 00.177-.427L2.715 4.215a6.491 6.491 0 012.314-1.998zM1.262 8.169a.75.75 0 00-1.22.658 8.001 8.001 0 0014.315 4.03l1.216 1.216a.25.25 0 00.427-.177V10.25a.25.25 0 00-.25-.25h-3.646a.25.25 0 00-.177.427l1.358 1.358a6.501 6.501 0 01-11.751-3.11.75.75 0 00-.272-.506z"></path><path d="M9.06 9.06a1.5 1.5 0 11-2.12-2.12 1.5 1.5 0 012.12 2.12z"></path></svg>{` `}<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path fillRule="evenodd" d="M6.749.097a8.054 8.054 0 012.502 0 .75.75 0 11-.233 1.482 6.554 6.554 0 00-2.036 0A.75.75 0 016.749.097zM4.345 1.693A.75.75 0 014.18 2.74a6.542 6.542 0 00-1.44 1.44.75.75 0 01-1.212-.883 8.042 8.042 0 011.769-1.77.75.75 0 011.048.166zm7.31 0a.75.75 0 011.048-.165 8.04 8.04 0 011.77 1.769.75.75 0 11-1.214.883 6.542 6.542 0 00-1.439-1.44.75.75 0 01-.165-1.047zM.955 6.125a.75.75 0 01.624.857 6.554 6.554 0 000 2.036.75.75 0 01-1.482.233 8.054 8.054 0 010-2.502.75.75 0 01.858-.624zm14.09 0a.75.75 0 01.858.624 8.057 8.057 0 010 2.502.75.75 0 01-1.482-.233 6.55 6.55 0 000-2.036.75.75 0 01.624-.857zm-13.352 5.53a.75.75 0 011.048.165 6.542 6.542 0 001.439 1.44.75.75 0 01-.883 1.212 8.04 8.04 0 01-1.77-1.769.75.75 0 01.166-1.048zm12.614 0a.75.75 0 01.165 1.048 8.038 8.038 0 01-1.769 1.77.75.75 0 11-.883-1.214 6.543 6.543 0 001.44-1.439.75.75 0 011.047-.165zm-8.182 3.39a.75.75 0 01.857-.624 6.55 6.55 0 002.036 0 .75.75 0 01.233 1.482 8.057 8.057 0 01-2.502 0 .75.75 0 01-.624-.858z"></path></svg></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><strong parentName="td">{`Issues`}</strong></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`The `}<inlineCode parentName="td">{`issue`}</inlineCode>{` icon is represented as a circle with an `}<inlineCode parentName="td">{`•`}</inlineCode>{` which is to represent an item to be done. A closed issue is conisdered "done" and is represented with a checkmark inside of the circle, and by combining the `}<inlineCode parentName="td">{`sync`}</inlineCode>{` icon with an `}<inlineCode parentName="td">{`•`}</inlineCode>{` for reopening an issue. A draft issue is represented with. adashed line around the `}<inlineCode parentName="td">{`•`}</inlineCode>{` symbol. These four symbols should be used exclusively with issues`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" className="octicon"><path fillRule="evenodd" d="M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z"></path></svg></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><strong parentName="td">{`Pull requests`}</strong></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`The `}<inlineCode parentName="td">{`pull request`}</inlineCode>{` icon is represented as a commit dot attached with an arrow being inserted into the history timeline (two dots connected by a line)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path fillRule="evenodd" d="M2 2.5A2.5 2.5 0 014.5 0h8.75a.75.75 0 01.75.75v12.5a.75.75 0 01-.75.75h-2.5a.75.75 0 110-1.5h1.75v-2h-8a1 1 0 00-.714 1.7.75.75 0 01-1.072 1.05A2.495 2.495 0 012 11.5v-9zm10.5-1V9h-8c-.356 0-.694.074-1 .208V2.5a1 1 0 011-1h8zM5 12.25v3.25a.25.25 0 00.4.2l1.45-1.087a.25.25 0 01.3 0L8.6 15.7a.25.25 0 00.4-.2v-3.25a.25.25 0 00-.25-.25h-3.5a.25.25 0 00-.25.25z"></path></svg></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><strong parentName="td">{`Repos`}</strong></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`A repository in GitHub is represented as a closed book and is explicitly named as `}<inlineCode parentName="td">{`repo`}</inlineCode>{`. Octicons does contain a `}<inlineCode parentName="td">{`book`}</inlineCode>{` icon which displays an open book symbol that is used for wikis, READMEs, and other use cases where the user can see a collection of information`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`GitHub brand specific`}</h3>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path fillRule="evenodd" d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"></path></svg>
    <p><strong parentName="p">{`GitHub mark`}</strong></p>
    <p>{`Brand logo use only. Follow `}<a parentName="p" {...{
        "href": "https://brand.github.com/"
      }}>{`GitHub's brand guidelines`}</a>{` when using this octicon.`}</p>
    <h2>{`Icon styling`}</h2>
    <p>{`By default, all octicons use an outline style. Some icons have a filled version which should be used only under the following conditions:`}</p>
    <DoDontContainer mdxType="DoDontContainer">
      <Do mdxType="Do">
    <img width="456" alt="octicons-style-pairing" src="https://user-images.githubusercontent.com/10384315/103719162-490c9600-4f7d-11eb-8d9c-1d867ee51de9.png" />
    <Caption mdxType="Caption">Use a filled icon to aid in contrast when in relation to another icon</Caption>
      </Do>
      <Do mdxType="Do">
    <img width="456" alt="In GitHub Mobile, the active page uses the filled icon to indicate where the user is within the app. In this screenshot the home icon is filled to indicate the user is on the Home screen." src="https://user-images.githubusercontent.com/10384315/104072766-ee637c00-51c0-11eb-8363-ea9b220f1fe3.png" />
    <Caption mdxType="Caption">Use a filled icon to indicate navigation state in GitHub's native mobile apps</Caption>
      </Do>
    </DoDontContainer>
    <h2>{`Icon states`}</h2>
    <p>{`The state of an action can be displayed either by using a stroke and fill icon pairing or using a slash version of an icon if available.`}</p>
    <h3>{`Outline and fill pairings`}</h3>
    <p>{`Use the outline icon for the "off"/"empty" state and the fill icons for "on"/"filled" states.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Metaphor`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Icon pairing`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Sponsor/Sponsoring`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path fillRule="evenodd" d="M4.25 2.5c-1.336 0-2.75 1.164-2.75 3 0 2.15 1.58 4.144 3.365 5.682A20.565 20.565 0 008 13.393a20.561 20.561 0 003.135-2.211C12.92 9.644 14.5 7.65 14.5 5.5c0-1.836-1.414-3-2.75-3-1.373 0-2.609.986-3.029 2.456a.75.75 0 01-1.442 0C6.859 3.486 5.623 2.5 4.25 2.5zM8 14.25l-.345.666-.002-.001-.006-.003-.018-.01a7.643 7.643 0 01-.31-.17 22.075 22.075 0 01-3.434-2.414C2.045 10.731 0 8.35 0 5.5 0 2.836 2.086 1 4.25 1 5.797 1 7.153 1.802 8 3.02 8.847 1.802 10.203 1 11.75 1 13.914 1 16 2.836 16 5.5c0 2.85-2.045 5.231-3.885 6.818a22.08 22.08 0 01-3.744 2.584l-.018.01-.006.003h-.002L8 14.25zm0 0l.345.666a.752.752 0 01-.69 0L8 14.25z"></path></svg>{` / `}<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path fillRule="evenodd" d="M7.655 14.916L8 14.25l.345.666a.752.752 0 01-.69 0zm0 0L8 14.25l.345.666.002-.001.006-.003.018-.01a7.643 7.643 0 00.31-.17 22.08 22.08 0 003.433-2.414C13.956 10.731 16 8.35 16 5.5 16 2.836 13.914 1 11.75 1 10.203 1 8.847 1.802 8 3.02 7.153 1.802 5.797 1 4.25 1 2.086 1 0 2.836 0 5.5c0 2.85 2.045 5.231 3.885 6.818a22.075 22.075 0 003.744 2.584l.018.01.006.003h.002z"></path></svg></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Star/Unstar`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path fillRule="evenodd" d="M8 .25a.75.75 0 01.673.418l1.882 3.815 4.21.612a.75.75 0 01.416 1.279l-3.046 2.97.719 4.192a.75.75 0 01-1.088.791L8 12.347l-3.766 1.98a.75.75 0 01-1.088-.79l.72-4.194L.818 6.374a.75.75 0 01.416-1.28l4.21-.611L7.327.668A.75.75 0 018 .25zm0 2.445L6.615 5.5a.75.75 0 01-.564.41l-3.097.45 2.24 2.184a.75.75 0 01.216.664l-.528 3.084 2.769-1.456a.75.75 0 01.698 0l2.77 1.456-.53-3.084a.75.75 0 01.216-.664l2.24-2.183-3.096-.45a.75.75 0 01-.564-.41L8 2.694v.001z"></path></svg>{` / `}<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path fillRule="evenodd" d="M8 .25a.75.75 0 01.673.418l1.882 3.815 4.21.612a.75.75 0 01.416 1.279l-3.046 2.97.719 4.192a.75.75 0 01-1.088.791L8 12.347l-3.766 1.98a.75.75 0 01-1.088-.79l.72-4.194L.818 6.374a.75.75 0 01.416-1.28l4.21-.611L7.327.668A.75.75 0 018 .25z"></path></svg></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Pass/Fail`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path fillRule="evenodd" d="M8 16A8 8 0 108 0a8 8 0 000 16zm3.78-9.72a.75.75 0 00-1.06-1.06L6.75 9.19 5.28 7.72a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l4.5-4.5z"></path></svg>{` / `}<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path fillRule="evenodd" d="M2.343 13.657A8 8 0 1113.657 2.343 8 8 0 012.343 13.657zM6.03 4.97a.75.75 0 00-1.06 1.06L6.94 8 4.97 9.97a.75.75 0 101.06 1.06L8 9.06l1.97 1.97a.75.75 0 101.06-1.06L9.06 8l1.97-1.97a.75.75 0 10-1.06-1.06L8 6.94 6.03 4.97z"></path></svg></td>
        </tr>
      </tbody>
    </table>
    <Note mdxType="Note">
      <p>{`The exception to this rule is when conveying a "pass"/"fail" pairing which is done using the filled version of the `}<inlineCode parentName="p">{`check-circle`}</inlineCode>{` and `}<inlineCode parentName="p">{`x-circle`}</inlineCode></p>
    </Note>
    <DoDontContainer mdxType="DoDontContainer">
      <Do mdxType="Do">
    <img width="456" alt="The file-directory icon uses a filled style to distinguish it apart from the file icons. In the example the file-directory icon is filled and blue and the file icon is outlined in light gray." src="https://user-images.githubusercontent.com/10384315/103833710-83863980-5036-11eb-9218-954cbc87fc85.png" />
    <Caption mdxType="Caption">Use outline and fill pairings to show the state of an action</Caption>
      </Do>
      <Do mdxType="Do">
    <img width="456" alt="octicon-actions" src="https://user-images.githubusercontent.com/10384315/103720006-3d21d380-4f7f-11eb-89b8-3b572f80e284.png" />
    <Caption mdxType="Caption">Use outline and fill pairings to indicate the status or completion of an action (for example, an action running)</Caption>
      </Do>
    </DoDontContainer>
    <h3>{`Slash icons`}</h3>
    <p>{`Specific icons have a stateful pair using a slash to indicate the "off/empty" state. Use these when indicating that an action is removing or disabling a function.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Metaphor`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Icon pairing`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Subscribe/Unsubscribe`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path d="M8 16a2 2 0 001.985-1.75c.017-.137-.097-.25-.235-.25h-3.5c-.138 0-.252.113-.235.25A2 2 0 008 16z"></path><path fillRule="evenodd" d="M8 1.5A3.5 3.5 0 004.5 5v2.947c0 .346-.102.683-.294.97l-1.703 2.556a.018.018 0 00-.003.01l.001.006c0 .002.002.004.004.006a.017.017 0 00.006.004l.007.001h10.964l.007-.001a.016.016 0 00.006-.004.016.016 0 00.004-.006l.001-.007a.017.017 0 00-.003-.01l-1.703-2.554a1.75 1.75 0 01-.294-.97V5A3.5 3.5 0 008 1.5zM3 5a5 5 0 0110 0v2.947c0 .05.015.098.042.139l1.703 2.555A1.518 1.518 0 0113.482 13H2.518a1.518 1.518 0 01-1.263-2.36l1.703-2.554A.25.25 0 003 7.947V5z"></path></svg>{` / `}<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path fillRule="evenodd" d="M8 1.5c-.997 0-1.895.416-2.534 1.086A.75.75 0 014.38 1.55 5 5 0 0113 5v2.373a.75.75 0 01-1.5 0V5A3.5 3.5 0 008 1.5zM4.182 4.31L1.19 2.143a.75.75 0 10-.88 1.214L3 5.305v2.642a.25.25 0 01-.042.139L1.255 10.64A1.518 1.518 0 002.518 13h11.108l1.184.857a.75.75 0 10.88-1.214l-1.375-.996a1.196 1.196 0 00-.013-.01L4.198 4.321a.733.733 0 00-.016-.011zm7.373 7.19L4.5 6.391v1.556c0 .346-.102.683-.294.97l-1.703 2.556a.018.018 0 00-.003.01.015.015 0 00.005.012.017.017 0 00.006.004l.007.001h9.037zM8 16a2 2 0 001.985-1.75c.017-.137-.097-.25-.235-.25h-3.5c-.138 0-.252.113-.235.25A2 2 0 008 16z"></path></svg></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Save/Unsave`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path fillRule="evenodd" d="M4.75 2.5a.25.25 0 00-.25.25v9.91l3.023-2.489a.75.75 0 01.954 0l3.023 2.49V2.75a.25.25 0 00-.25-.25h-6.5zM3 2.75C3 1.784 3.784 1 4.75 1h6.5c.966 0 1.75.784 1.75 1.75v11.5a.75.75 0 01-1.227.579L8 11.722l-3.773 3.107A.75.75 0 013 14.25V2.75z"></path></svg>{` / `}<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path fillRule="evenodd" d="M1.19 1.143a.75.75 0 10-.88 1.214L3 4.305v9.945a.75.75 0 001.206.596L8 11.944l3.794 2.902A.75.75 0 0013 14.25v-2.703l1.81 1.31a.75.75 0 10.88-1.214l-2.994-2.168a1.09 1.09 0 00-.014-.01L4.196 3.32a.712.712 0 00-.014-.01L1.19 1.143zM4.5 5.39v7.341l3.044-2.328a.75.75 0 01.912 0l3.044 2.328V10.46l-7-5.07zM5.865 1a.75.75 0 000 1.5h5.385a.25.25 0 01.25.25v3.624a.75.75 0 001.5 0V2.75A1.75 1.75 0 0011.25 1H5.865z"></path></svg></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Watch/Unwatch`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path fillRule="evenodd" d="M1.679 7.932c.412-.621 1.242-1.75 2.366-2.717C5.175 4.242 6.527 3.5 8 3.5c1.473 0 2.824.742 3.955 1.715 1.124.967 1.954 2.096 2.366 2.717a.119.119 0 010 .136c-.412.621-1.242 1.75-2.366 2.717C10.825 11.758 9.473 12.5 8 12.5c-1.473 0-2.824-.742-3.955-1.715C2.92 9.818 2.09 8.69 1.679 8.068a.119.119 0 010-.136zM8 2c-1.981 0-3.67.992-4.933 2.078C1.797 5.169.88 6.423.43 7.1a1.619 1.619 0 000 1.798c.45.678 1.367 1.932 2.637 3.024C4.329 13.008 6.019 14 8 14c1.981 0 3.67-.992 4.933-2.078 1.27-1.091 2.187-2.345 2.637-3.023a1.619 1.619 0 000-1.798c-.45-.678-1.367-1.932-2.637-3.023C11.671 2.992 9.981 2 8 2zm0 8a2 2 0 100-4 2 2 0 000 4z"></path></svg>{` / `}<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path fillRule="evenodd" d="M.143 2.31a.75.75 0 011.047-.167l14.5 10.5a.75.75 0 11-.88 1.214l-2.248-1.628C11.346 13.19 9.792 14 8 14c-1.981 0-3.67-.992-4.933-2.078C1.797 10.832.88 9.577.43 8.9a1.618 1.618 0 010-1.797c.353-.533.995-1.42 1.868-2.305L.31 3.357A.75.75 0 01.143 2.31zm3.386 3.378a14.21 14.21 0 00-1.85 2.244.12.12 0 00-.022.068c0 .021.006.045.022.068.412.621 1.242 1.75 2.366 2.717C5.175 11.758 6.527 12.5 8 12.5c1.195 0 2.31-.488 3.29-1.191L9.063 9.695A2 2 0 016.058 7.52l-2.53-1.832zM8 3.5c-.516 0-1.017.09-1.499.251a.75.75 0 11-.473-1.423A6.23 6.23 0 018 2c1.981 0 3.67.992 4.933 2.078 1.27 1.091 2.187 2.345 2.637 3.023a1.619 1.619 0 010 1.798c-.11.166-.248.365-.41.587a.75.75 0 11-1.21-.887c.148-.201.272-.382.371-.53a.119.119 0 000-.137c-.412-.621-1.242-1.75-2.366-2.717C10.825 4.242 9.473 3.5 8 3.5z"></path></svg></td>
        </tr>
      </tbody>
    </table>
    <Do mdxType="Do">
    <img width="456" alt="The save and subscribe action buttons in notifications are special cases where a slash version of the icon is used for the 'off'/'empty' state." src="https://user-images.githubusercontent.com/10384315/103726215-3b5f0c80-4f8d-11eb-974a-8efc2a8643a6.png" />
    <Caption mdxType="Caption">The save and subscribe action buttons in notifications are special cases where a slash version of the icon is used for the "off"/"empty" state.</Caption>
    </Do>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      